import {
  List,
  Datagrid,
  TextField,
  ChipField,
  ArrayField,
  ReferenceField,
  BooleanField,
  NumberField,
  SearchInput,
  TextInput,
  Show,
  SimpleShowLayout,
} from 'react-admin'

import { TelegramLinkField } from '../components/TelegramLinkField'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const UserList = ({ isEdit, isDelete }) => (
  <List filters={[<SearchInput source="search" alwaysOn />, <TextInput source="search" />]}>
    <Datagrid bulkActionButtons={false} rowClick="show">
      <TextField source="name" />
      <TextField source="walletAddress" />
      <TextField source="telegramId" />
      <TelegramLinkField source="tgUsername" />
      <TextField source="twitterUserName" />
      <NumberField source="totalPoints" />
    </Datagrid>
  </List>
)

export const UserShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="name" />
      <TextField source="walletAddress" />
      <ArrayField source="wallets">
        <Datagrid>
          <ChipField source="networkType" />
          <TextField source="address" />
          <TextField source="signature" />
          <TextField source="digest" />
        </Datagrid>
      </ArrayField>
      <TextField source="telegramId" />
      <TelegramLinkField source="tgUsername" />
      <TextField source="twitterUserName" />
      <BooleanField source="isNotificationsOn" />
      <TextField source="signature" />
      <TextField source="digest" />
      <NumberField source="totalPoints" />
    </SimpleShowLayout>
  </Show>
)
